import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title_info: 'Information',
    title_location: 'Master Location Container',
    title_photos: 'Photo Container',
    title_cleaning: 'Container Cleaning',
    title_condition: 'Container Condition',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Container',
        href: '/adm/opr/container',
        active: true,
      },
    ],
    tab_photo: [
      'Survey In',
      'Damage',
      'Crani In',
      'QC',
      'QC PTI',
      'Crani Out',
      'Survey Out',
      'Photo Complete',
    ],
    tab_active: 'Survey In',
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields_cleaning: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'cleaning',
        label: 'Clean Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Interchange',
        sortable: true,
      },
      {
        key: 'date',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_condition: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Doc No',
        sortable: true,
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: true,
      },
    ],
    fields_info: [
      {
        key: 'date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'description',
        label: 'Note',
        sortable: true,
      },
      {
        key: 'activity',
        label: 'Activity',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Doc No',
        sortable: true,
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: true,
      },
      {
        key: 'app_date',
        label: 'App Date',
      },
      {
        key: 'app_by',
        label: 'App By',
      },
    ],
    fields_loc: [
      {
        key: 'code_cont',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'cont_description',
        label: 'Deskripsi',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      code_cont: '',
      cont_description: '',
      id_principle: '',
      code_principle: '',
      name_principle: '',
      prefix: '',
      number: '',
    },
    images: [],
    loading: false,
  },
};

export const mutations = {
  changeContainer(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const actions = {
  async getContainerCleaning({ commit, state }) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let form = data.form;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/container/cleaning`, params);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getContainerPhoto({ commit, state }) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      photo_type: data.tab_active,
    };

    let result = await ApiGetRequest(`opr/container/photo`, params);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        images: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getContainerLocation({ commit, state }) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/container/location`, params);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getConditionContainer({ commit, state }) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let form = data.form;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort:
        data.sortBy === 'id_photo' || data.sortBy === 'id_interchange_detail'
          ? 'id_container_history'
          : data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      size: form.size || '',
      type: form.type || '',
      condition: form.condition || '',
      doc_type: form.doc_type || '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/container/condition`, params);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async updateInfoContainer({ commit, dispatch }, payload = null) {
    let result = await ApiPutRequest(
      `opr/container/info/${payload.id}`,
      payload.data
    );
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        loading: false,
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDownloadFilesMulti({ commit }, payload = null) {
    commit('changeContainer', {
      loading: true,
    });

    let result = await ApiPostRequest('opr/download/multi', {
      ...payload,
    });

    commit('changeContainer', {
      loading: false,
    });
    if (result) {
      return result.data.object;
    }
  },

  async getInfoContainer({ commit, state }) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let form = data.form;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: ['id_photo', 'id_interchange_detail'].includes(data.sortBy)
        ? 'id_container_history'
        : data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      prefix: form.prefix ? form.prefix : '',
      number: form.number ? form.number : '',
    };

    let result = await ApiGetRequest(`opr/container/history`, params);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getDetailContainerLocation({ commit, state }, payload = null) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/container/location/${payload.id}`);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      commit('changeContainer', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });

      return true;
    }

    return false;
  },

  async createContainerLocation({ commit, state, dispatch }) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/container/location`, data.form);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateContainerLocation({ commit, state, dispatch }, payload = null) {
    commit('changeContainer', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/container/location/${payload.id}`,
      data.form
    );
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteContainerLocation({ commit, dispatch }, payload = null) {
    commit('changeContainer', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/container/location/${payload.id}`);
    commit('changeContainer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    return false;
  },
};
